import { ReactElement, ReactNode } from 'react';
import { debug } from 'zf-web-infra';
import { Input as BaseInput, InputNumber } from 'antd';
import { ColumnProps } from 'antd/es/table';
import { InputProps } from '../types';

export function Input<T>(props: InputProps<T>): ReactElement | null {
  debug.common('Input', props);
  return null;
}

Input.displayName = 'Input';

export function getInputProps<T>(child: ReactElement<ColumnProps<T>>): ColumnProps<T> {
  debug.common('getInputProps');

  const { placeholder, onChange, dataIndex, type } = child.props as InputProps<T>;
  if (type === 'number') {
    return {
      render: (value, record: T, index: number): ReactNode => (
        <InputNumber
          placeholder={placeholder}
          value={value}
          onChange={value => {
            onChange?.((value ?? '').toString(), record, { index, dataIndex });
          }}
        />
      ),
      ...child.props
    };
  }

  return {
    render: (value, record: T, index: number): ReactNode => (
      <BaseInput
        placeholder={placeholder}
        value={value}
        onChange={({ target }) => onChange?.(target.value, record, { index, dataIndex })}
      />
    ),
    ...child.props
  };
}
